import { Testimoni } from '@merchant-portal/app/models/testimoni/testimoni.interface';

export const testimonies: Testimoni[] = [
  {
    text: '“Pivot boosted our payout success rate close to 100% and cut our operational costs by up to 10%. Their support team is always fast, friendly, and truly cares. Every problem is heard, every fix comes fast. It’s like having a real partner, not just a provider.”',
    author: {
      name: 'Yudianto Soeharli',
      title: 'Finance Operation Manager at Paper.id',
      avatar: 'https://storage.googleapis.com/pg-staging-static-files/testimonies/avatar/paper.png',
    },
  },
  {
    text: '“The disbursement system has proven to be effective in enabling fast and well-controlled fund releases. On the security front, it’s also solid! Each file upload includes a validation step to ensure the accuracy of recipient accounts.”',
    author: {
      name: 'Nadiah Shahab',
      title: 'CFO at Janji Jiwa',
      avatar:
        'https://storage.googleapis.com/pg-staging-static-files/testimonies/avatar/janji-jiwa.png',
    },
  },
  {
    text: '“We’re thrilled with our partnership with Pivot. They’ve gone above and beyond to deliver tailored, effective solutions. Their expertise, responsiveness, and commitment to our success have been instrumental in helping us achieve the outcomes we envisioned.”',
    author: {
      name: 'Thomas',
      title: 'Head of Development at Ambil Gaji Duluan',
      avatar: 'https://storage.googleapis.com/pg-staging-static-files/testimonies/avatar/atoer.png',
    },
  },
];
